import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';

import { Button, ButtonSize, ButtonType } from '../Button';

export interface Props {
  count: number;
  increment(): void;
  decrement(): void;
}

export const Counter = (props: Props): JSX.Element => {
  const { count, increment, decrement } = props;

  return (
    <div className='flex items-center pl-8'>
      <Button
        aria-label='Decrement'
        buttonType={ButtonType.rounded}
        buttonSize={ButtonSize.mediumSquare}
        onClick={decrement}
      >
        <FontAwesomeIcon icon={faMinus}/>
      </Button>
      <span className='text-xl px-4'>{count}</span>
      <Button
        aria-label='Increment'
        buttonType={ButtonType.rounded}
        buttonSize={ButtonSize.mediumSquare}
        onClick={increment}
      >
        <FontAwesomeIcon icon={faPlus}/>
      </Button>
    </div>
  );
};
